import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PurchaseOrderDetailsResponse } from 'lib/api/publicMarket';

export type TenderModalState = {
  open: boolean;
  purchaseOrder: PurchaseOrderDetailsResponse | null;
};

const initialState: TenderModalState = {
  open: false,
  purchaseOrder: null,
};

const purchaseOrderModalSlice = createSlice({
  name: 'purchaseOrderModal',
  initialState,
  reducers: {
    showPurchaseOrderModal: (
      state,
      action: PayloadAction<PurchaseOrderDetailsResponse>,
    ) => {
      state.open = true;
      state.purchaseOrder = action.payload;
    },
    hidePurchaseOrderModal: (state) => {
      state.open = false;
      state.purchaseOrder = null;
    },
  },
});

export const { showPurchaseOrderModal, hidePurchaseOrderModal } =
  purchaseOrderModalSlice.actions;
export default purchaseOrderModalSlice.reducer;
